import { render, staticRenderFns } from "./ContactMe.vue?vue&type=template&id=0b838dcf&scoped=true&"
import script from "./ContactMe.vue?vue&type=script&lang=js&"
export * from "./ContactMe.vue?vue&type=script&lang=js&"
import style0 from "./ContactMe.vue?vue&type=style&index=0&id=0b838dcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b838dcf",
  null
  
)

export default component.exports